angular.module('galilai.creator').service('mediaService', function() {

    let previewMap = {}

    const PREVIEW_AUDIO_DURATION = 90000
    this.previewAudio = function(media, cb) {
        let kindPreview = 'audio'
        function stopAudio(audio) {
            audio.pause();
            audio.src = ''; // Clear the source
            audio.load(); // Reset the audio element
        }

        function stopPreview(url) {
            if (previewMap[kindPreview]) {
                let timer = previewMap[kindPreview].timer
                if (timer) {
                    clearTimeout(timer)
                }
                if (previewMap[kindPreview].media) {
                    let currentURL = previewMap[kindPreview].media.src
                    stopAudio(previewMap[kindPreview].media)
                    if (currentURL == url) {
                        return true
                    }
                }
            }
            return false
        }
        function previewAudio(url) {
            // Stop any previous audio
            if (stopPreview(url)) {
                if (cb) {
                    cb()
                }
                return;
            }

            // Create an audio element
            var audio = null
            if (!previewMap[kindPreview]) {
                previewMap[kindPreview] = {
                    timer: null,
                    media: new Audio(),
                }
            }
            audio = previewMap[kindPreview].media
            audio.pause()
            audio.src = media.data.url;
            audio.load();
            audio.play();

            // Set a timeout to pause and destroy the audio object after 30 seconds
            let timer = setTimeout(function() {
                if (cb) {
                    cb()
                }
                stopAudio(audio);
            }, PREVIEW_AUDIO_DURATION);
            previewMap[kindPreview].timer = timer;
        }

        previewAudio(media.data.url)
    }
})